export default __webpack_public_path__ + "static/media/img9.9d8807dd.jpg";